export const taskStatusName = {
	0: "未提交",
	1: "待审阅",
	2: "导师已审阅",
	3: "已过期"
};

export const messageStatusName = {
	0: "未读",
	1: "已读"
};



// WEBPACK FOOTER //
// ./src/common/map.js